/*
 * File: d:\projects\AutoFiFront\src\Content\RGPD\RGPD.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Thursday April 20th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday April 20th 2023 11:16:59 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import translator from 'MultiLanguage/TranslationWrapper';
import { BuildText } from 'Utils/BuildText';
import styles from 'Content/RGPD/RGPD.module.css';

function RGPD() {
    const rgpdObject = translator.decode("rgpd");
    const rows = BuildText(rgpdObject,"rgpd");

    return (
        <div className={`${styles.rgpd}`}>
            <h1 className={`mt-3 ${styles.title}`}>{rgpdObject.title}</h1>
            {rows}
            <a href="https://www.cnil.fr/fr/comprendre-vos-droits">https://www.cnil.fr/fr/comprendre-vos-droits</a>
            <br/>
            <br/>
            {translator.decode("rgpd.contact")}
            <a href="mailto:contact@mobyfleet.fr">{translator.decode("rgpd.contactMail")}</a>
        </div>
    );
};

export default RGPD;
